import { AbstractControl, ValidationErrors } from '@angular/forms';
import { isValid, parse } from 'date-fns';
import { isoDateYYYYMMDDRegex } from '@shared/constants/regex.const';
import { isNilOrEmpty } from '@shared/helpers/utils.helper';
import { DATE_NOT_ALLOWED, INVALID_DATE, MAX_ANNO_DATA, MIN_ANNO_DATA } from '@shared/constants/shared.constants';

/**
 * Valida la coerenza di una data ISO (yyyy-MM-dd) proveniente da <input type="date">.
 * Blocca: anni a 5-6 cifre, anni < MIN_ANNO_DATA (es. 0024), anni > MAX_ANNO_DATA,
 * date di calendario impossibili. Ignora il campo vuoto (l'obbligatorietà è gestita altrove).
 * Ritorna { dateCoherence: { status } } per compatibilità con field-errors.component.
 */
export const dateCoherenceValidator = (control: AbstractControl): ValidationErrors | null => {
    const value = (control?.value ?? '').toString().trim();
    if (isNilOrEmpty(value)) {
        return null;
    }

    // Il regex richiede ESATTAMENTE 4 cifre nell'anno → cattura gli anni a 5-6 cifre.
    if (!isoDateYYYYMMDDRegex.test(value)) {
        return { dateCoherence: { status: INVALID_DATE } };
    }

    const anno = Number(value.slice(0, 4));
    if (anno < MIN_ANNO_DATA || anno > MAX_ANNO_DATA) {
        return { dateCoherence: { status: DATE_NOT_ALLOWED } };
    }

    // Data di calendario reale (es. 2024-02-31 → invalida).
    if (!isValid(parse(value, 'yyyy-MM-dd', new Date()))) {
        return { dateCoherence: { status: INVALID_DATE } };
    }

    return null;
};
